import { useContext } from 'react';
import PartnerAuthContext from 'contexts/PartnerAuthContext';

/**
 * Active auth identity for the current scope.
 *
 * Standalone MP app: the source version fell back to the main JWT auth
 * (`useAuth`) when no PartnerAuthProvider was mounted. Here the partner scope
 * is the only one, so this returns the partner identity directly. Pages that
 * are shared with the main app keep calling this hook unchanged.
 */
export interface ActiveAuth {
    isLoggedIn: boolean;
    userId?: string | number;
    username?: string;
    displayName?: string;
    role?: string;
    terminalName?: string;
    enclosureId?: string | number;
    enclosureName?: string;
    operatorId?: string | number;
    scope: 'partner';
    openLogin: () => void;
}

const useActiveAuth = (): ActiveAuth => {
    const partner = useContext(PartnerAuthContext);

    return {
        isLoggedIn: partner?.isLoggedIn ?? false,
        userId: partner?.user?.userId,
        username: partner?.user?.username,
        displayName: partner?.user?.displayName,
        role: partner?.user?.role,
        terminalName: partner?.user?.terminalName,
        // Only the partner-login's enclosureId is used for downstream calls
        // (bet, etc.) — never the URL's enclosure.
        enclosureId: partner?.user?.enclosureId,
        enclosureName: partner?.enclosureName,
        operatorId: partner?.user?.operatorId,
        scope: 'partner',
        openLogin: () => window.dispatchEvent(new Event('partner:open-login'))
    };
};

export default useActiveAuth;
